import { OvlAddScreen } from "../../../../../../../_ovlclient/src/global/globals"
import { CompKPIAll } from "./kpiall"

export const KPIAll_Init = () => {
  OvlAddScreen(CompKPIAll, "KPIAll")
}
